import * as React from 'react';
import type { SVGProps } from 'react';
const SvgItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12.49 3.3a.75.75 0 0 1 .431.97L8.38 16.077a.75.75 0 0 1-1.4-.538L11.521 3.73a.75.75 0 0 1 .97-.43Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M7.838 4a.75.75 0 0 1 .75-.75H15.4a.75.75 0 1 1 0 1.5H8.588a.75.75 0 0 1-.75-.75M3.75 15.809a.75.75 0 0 1 .75-.75h6.813a.75.75 0 0 1 0 1.5H4.5a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgItalic;
